import { useState } from 'react';
import type { EmployeeQuote } from '../quotes';

const useEmployeeQuote = (quotes: EmployeeQuote[]): EmployeeQuote => {
  const [quoteIndex] = useState<number>(Math.floor(Math.random() * quotes.length));
  return quotes[quoteIndex];
};

export { useEmployeeQuote as default, EmployeeQuote };
